'use client';

import { useState } from 'react';

type Item = { question: string; answer: string };

export function FAQAccordion({ items }: { items: Item[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="flex flex-col divide-y divide-black/[0.08] border-y border-black/[0.08]">
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={i} className="py-6">
            <button
              onClick={() => setOpenIndex(isOpen ? null : i)}
              className="flex items-start justify-between gap-6 w-full text-left cursor-pointer"
              aria-expanded={isOpen}
            >
              <span className="text-subheadline font-medium text-font-secondary leading-snug">
                {item.question}
              </span>
              <span
                aria-hidden="true"
                className={`shrink-0 mt-1.5 text-font-secondary/60 text-2xl leading-none select-none transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}
              >
                +
              </span>
            </button>
            <div
              className="grid transition-[grid-template-rows] duration-300 ease-in-out"
              style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
            >
              <div className="overflow-hidden">
                <p className="mt-4 text-nav text-font-tertiary leading-relaxed max-w-3xl">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
